import React from "react";
import {
  MobileAlertOverlay,
  MobileAlertCard,
  MobileAlertTitle,
  MobileAlertMessage,
  MobileAlertInstruction,
  AcademyButton,
} from "./styled";

interface MobileAlertProps {
  isVisible: boolean;
  translations?: {
    title: string;
    message: string;
    instruction: string;
  };
  assistantSource?: string;
}

const MobileAlert: React.FC<MobileAlertProps> = ({
  isVisible,
  translations,
  assistantSource,
}) => {
  if (!isVisible) return null;

  return (
    <MobileAlertOverlay>
      <MobileAlertCard>
        <MobileAlertTitle>{translations?.title}</MobileAlertTitle>
        <MobileAlertMessage>{translations?.message}</MobileAlertMessage>
        <MobileAlertInstruction>
          {translations?.instruction}
        </MobileAlertInstruction>
        {assistantSource === "academy" && (
          <AcademyButton
            href="https://talento.lapieza.io/"
            target="_blank"
            rel="noopener noreferrer"
          >
            Ir a Academy
          </AcademyButton>
        )}
      </MobileAlertCard>
    </MobileAlertOverlay>
  );
};

export default MobileAlert;
